import { Component, forwardRef, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { QuillEditorBase } from 'ngx-quill';

@Component({
    selector: 'dcs-editor',
    templateUrl: 'dcs-editor.component.html',
    styleUrls: ['dcs-editor.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DcsEditorComponent),
            multi: true
        }
    ]
})
export class DcsEditorComponent implements ControlValueAccessor, AfterViewInit {
    @ViewChild('quill') quill?: QuillEditorBase;
    private onTouchedCallback!: () => void;
    private onChangeCallback!: (_: any) => void;

    async ngAfterViewInit() {
        
    }

    private _name: string = "";
    @Input()
    get name(): string {

        return this._name;
    }
    set name(value: string) {

        this._name = value;
    }

    private innerValue: any = "";
    get value(): any {
        return this.innerValue;
    }

    @Input()
    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChangeCallback(v);
        }
    }

    private _fullpage: string = ""
    @Input()
    get fullpage(): string {

        return this._fullpage
    }
    set fullpage(value: string) {

        this._fullpage = value;
    }

    _type: number = 0;

    @Input()
    set type(type: number) {
        this._type = type;
    }
    get type(): number {
        return this._type
    }

    _height: number = 400;
    @Input()
    set height(type: number) {
        this._height = type;
        this.setHeight(this._height);
    }
    get height(): number {
        return this._height
    }

    async setHeight(height: any) {

    }

    writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }

    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
}
